import { render, staticRenderFns } from "./TextAnswerType.vue?vue&type=template&id=50932f9c&"
import script from "./TextAnswerType.vue?vue&type=script&lang=js&"
export * from "./TextAnswerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports